import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"
import parse from "html-react-parser"
import { isEmpty, sortBy } from "lodash"
import Button from "components/common/Button"
import InputField from "components/input"
import {
  saveProgress,
  completeCourseware,
  startExam,
  submitAnswer,
} from "store/user/actions"
import { paginate } from "helpers/util"
import "bulma-steps/dist/css/bulma-steps.min.css"
import styled from "styled-components"
import CheckBox from "components/checkbox"
import FormRadio from "components/form/radio"

const HTMLContainer = styled.div`
  text-align: justify;
  a,
  input,
  textarea,
  button,
  select {
    outline: none;
  }
  a:hover,
  h1:focus,
  h2:focus,
  h3:focus,
  h4:focus,
  h5:focus,
  h6:focus {
    text-decoration: none;
  }
  a:focus,
  input:focus,
  textarea:focus,
  button:focus,
  select:focus {
    outline: none !important;
    text-decoration: none;
  }
  input,
  textarea {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    border-radius: 0;
  }
  a {
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  img {
    max-width: 100%;
    width: auto;
    height: auto;
    vertical-align: middle;
    border: 0;
  }

  p {
    font-size: 16.8px;
    color: #040316 !important;
  }

  label {
    font-weight: 400;
  }

  h1 {
    line-height: 1.618;
  }

  textarea {
    width: 100%;
    height: 100px;
    font-size: 14px;
    padding: 10px 14px;
    resize: none;
    line-height: 1.5em;
    border: 1px solid #d4d4d4;
  }

  blockquote {
    font-weight: 700;
    border-left: 3px solid #428bca;
    margin: 0 1rem;
  }
  blockquote p {
    font-style: italic;
    font-size: 14px;
  }
  blockquote cite {
    font-size: 13px;
    color: #428bca;
  }
  blockquote cite:before {
    content: "- ";
  }
  blockquote cite:after {
    content: " -";
  }
`

class Survey extends Component {
  state = {
    activeStep: 1,
    maxSteps: 10,
    fieldErrors: {},
    answerSheet: {},
    formSheet: {},
    showResults: false,
  }

  componentDidMount() {
    const { data, completeCourseware } = this.props
    let newAnswerSheet = {}
    //TODO - Fix ESLint Roles for data mapping
    let arr = data?.exam_submission?.questions.forEach((question) => {
      newAnswerSheet[question.id] = question.answer?.answer
    })
    this.setState(
      {
        answerSheet: newAnswerSheet,
        activeStep:
          parseInt(localStorage.getItem(data.id)) <= 0
            ? 1
            : parseInt(localStorage.getItem(data.id)) || 1,
      },
      () => console.log(arr)
    )

    if (data?.exam_submission?.submitted) {
      if (!data?.completed) {
        completeCourseware({ id: data.id })
      }

      this.setState({ showResults: true })
    }

    return null
  }

  handleStartSurvey = (id) => {
    const { startExam } = this.props
    startExam(id)
  }

  handleSetSelectedPage = (step) => {
    this.setState({ activeStep: step + 1 })
  }

  handleSetNextPage = () => {
    const { activeStep } = this.state
    this.setState({ activeStep: activeStep + 1 })
  }

  handleSetPreviousPage = () => {
    const { activeStep } = this.state
    this.setState({ activeStep: activeStep - 1 })
  }

  handleSelectPage = (id, step) => {
    const { activeStep, maxSteps } = this.state
    const { data } = this.props

    let examQuestions = paginate(
      data?.exam_submission?.questions,
      maxSteps,
      activeStep
    )

    let activeQuestion =
      examQuestions.find((item) => item.order === step + 1) || {}

    if (!isEmpty(activeQuestion.answer?.answer)) {
      localStorage.setItem(id, step + 1)
      this.handleSetSelectedPage(step)
    }
  }

  handleNext = () => {
    const { activeStep, maxSteps, answerSheet, formSheet } = this.state
    const { data, submitAnswer } = this.props

    let examQuestions = paginate(
      data?.exam_submission?.questions,
      maxSteps,
      activeStep
    )

    let activeQuestion =
      examQuestions.find((item) => item.order === activeStep) || {}

    let requestData = {
      answer: answerSheet[activeQuestion.id],
    }

    const formData = new FormData()
    formData.append("answer", formSheet[activeQuestion.id])

    if (isEmpty(answerSheet[activeQuestion.id])) {
      if (
        activeQuestion.type === "radio" ||
        activeQuestion.type === "checkbox"
      ) {
        this.validateField(activeQuestion.id, "Please select an answer")
      } else {
        this.validateField(activeQuestion.id)
      }
    } else if (activeStep === data?.exam_submission?.total_questions) {
      if (activeQuestion.type === "file") {
        submitAnswer({ id: activeQuestion.id, data: formData })
      } else {
        submitAnswer({ id: activeQuestion.id, data: requestData })
      }
      localStorage.removeItem(data.id)
    } else {
      if (answerSheet[activeQuestion.id] !== activeQuestion.answer?.answer) {
        if (activeQuestion.type === "file") {
          submitAnswer({ id: activeQuestion.id, data: formData })
        } else {
          submitAnswer({ id: activeQuestion.id, data: requestData })
        }
        localStorage.setItem(data.id, activeStep + 1)
      } else {
        localStorage.setItem(data.id, activeStep + 1)
        this.handleSetNextPage()
      }
    }
  }

  handlePrevious = () => {
    const { activeStep } = this.state
    const { data } = this.props

    if (activeStep > 1) {
      localStorage.setItem(data.id, activeStep - 1)
      this.handleSetPreviousPage()
    } else {
      localStorage.setItem(data.id, 1)
    }
  }

  validateField = (name, message) => {
    const { answerSheet } = this.state
    let fieldErrors = this.state.fieldErrors

    if (isEmpty(message)) {
      message = "This field is required"
    }

    if (isEmpty(answerSheet[name])) {
      fieldErrors[name] = message
    } else {
      delete fieldErrors[name]
    }

    this.setState({ fieldErrors })
  }

  handleInputChange = (e) => {
    const { answerSheet } = this.state
    const { value, name } = e.currentTarget
    this.setState(
      {
        answerSheet: {
          ...answerSheet,
          [name]: value,
        },
      },
      () => this.validateField(name)
    )
  }

  handleSelect = (e) => {
    const { answerSheet } = this.state
    const { name, value } = e.currentTarget
    this.setState(
      {
        answerSheet: {
          ...answerSheet,
          [name]: value,
        },
      },
      () => this.validateField(name)
    )
  }

  handleSelectSingle = (name, value) => {
    const { answerSheet } = this.state
    this.setState(
      {
        answerSheet: {
          ...answerSheet,
          [name]: value,
        },
      },
      () => this.validateField(name)
    )
  }

  handleSelectMultiple = (e) => {
    const { answerSheet } = this.state
    const target = e.currentTarget
    const { value, name } = target

    if (target.checked) {
      if (isEmpty(answerSheet[name])) {
        this.setState(
          {
            answerSheet: {
              ...answerSheet,
              [name]: [value],
            },
          },
          () => this.validateField(name, "Please select an answer")
        )
      } else {
        this.setState(
          {
            answerSheet: {
              ...answerSheet,
              [name]: [...answerSheet[name], value],
            },
          },
          () => this.validateField(name, "Please select an answer")
        )
      }
    } else {
      this.setState(
        {
          answerSheet: {
            ...answerSheet,
            [name]: answerSheet[name].filter((item) => item !== value),
          },
        },
        () => this.validateField(name, "Please select an answer")
      )
    }
  }

  handleFileSelect = (e) => {
    const { answerSheet, formSheet } = this.state
    const { value, name } = e.currentTarget
    this.setState(
      {
        answerSheet: {
          ...answerSheet,
          [name]: value,
        },
        formSheet: {
          ...formSheet,
          [name]: e.target.files[0],
        },
      },
      () => this.validateField(name, "No file is chosen")
    )
  }

  handleViewResults = () => {
    const { showResults } = this.state
    this.setState({ showResults: !showResults })
  }

  handleViewFile = (value) => {
    window.open(value, "_blank")
  }

  handleViewNextCourseWare = () => {
    const { onNextCourseware = false } = this.props

    if (onNextCourseware) {
      onNextCourseware()
    }
  }

  displayExamType = (data) => {
    const { answerSheet, fieldErrors } = this.state
    const { activeStep, maxSteps } = this.state
    const { data: propData } = this.props

    let examQuestions = paginate(
      propData?.exam_submission?.questions,
      maxSteps,
      activeStep
    )

    let activeQuestion =
      examQuestions.find((item) => item.order === activeStep) || {}

    switch (data.type) {
      case "text":
        return (
          <Fragment>
            <div className="control">
              <InputField
                placeholder="Enter your answer here"
                name={data.id}
                value={answerSheet[data.id]}
                error={fieldErrors[data.id]}
                onChange={this.handleInputChange}
              />
            </div>
          </Fragment>
        )

      case "textarea":
        return (
          <Fragment>
            <InputField
              type="textarea"
              placeholder="Enter your answer here"
              name={data.id}
              value={answerSheet[data.id]}
              error={fieldErrors[data.id]}
              onChange={this.handleInputChange}
            />
          </Fragment>
        )

      case "radio":
        return (
          <Fragment>
            <div className="control exam-radio">
              <span className="choices-header">Select your answer</span>
              {data.choices?.map((item, i) => (
                <FormRadio
                  id={i}
                  key={i}
                  name={data.id}
                  checked={answerSheet[data.id]?.includes(item)}
                  onChange={() => this.handleSelectSingle(data.id, item)}
                  text={item}
                />
              ))}
            </div>
            {fieldErrors[data.id] && (
              <p className="error-message">{`* ${fieldErrors[data.id]}`}</p>
            )}
          </Fragment>
        )

      case "checkbox":
        return (
          <Fragment>
            <div className="control exam-checkbox">
              <span className="choices-header">Select your answer</span>
              <span className="choices-subheader">
                Check all possible answers.
              </span>
              {data.choices?.map((item, i) => (
                <CheckBox
                  name={data.id}
                  value={item}
                  id={`chk-choice-${data.id}-${i}`}
                  checked={answerSheet[data.id]?.includes(item)}
                  onChange={this.handleSelectMultiple}
                  text={item}
                />
              ))}
            </div>
            {fieldErrors[data.id] && (
              <p className="error-message">{`* ${fieldErrors[data.id]}`}</p>
            )}
          </Fragment>
        )

      case "select":
        return (
          <Fragment>
            <div className="exam-select">
              <span className="choices-header">Select your answer</span>
              <div className="select-wrapper" id="sort">
                <select
                  name={data.id}
                  className="select"
                  onChange={this.handleSelect}
                  value={[answerSheet[data.id]]}
                >
                  {data.answer?.answer ? (
                    ""
                  ) : (
                    <option value={null} key={-1}>
                      Select answer...
                    </option>
                  )}
                  {data.choices?.map((item, index) => (
                    <option value={item} key={index}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {fieldErrors[data.id] && (
              <p className="error-message">{`* ${fieldErrors[data.id]}`}</p>
            )}
          </Fragment>
        )

      case "file":
        return (
          <Fragment>
            <div className="file-container">
              <input
                type="file"
                name={data.id}
                onChange={this.handleFileSelect}
                required
              />
            </div>
            {activeQuestion.answer?.answer && (
              <Button
                label="View File"
                ghost
                onClick={() =>
                  this.handleViewFile(activeQuestion.answer?.answer)
                }
              />
            )}
            {fieldErrors[data.id] && (
              <p className="error-message">{`* ${fieldErrors[data.id]}`}</p>
            )}
          </Fragment>
        )

      default:
    }
  }

  render() {
    const {
      data,
      school: { schoolData },
    } = this.props

    const { activeStep, maxSteps, showResults } = this.state

    let examQuestions = [],
      activeQuestion = {}
    if (!isEmpty(data?.exam_submission)) {
      examQuestions = paginate(
        data?.exam_submission?.questions,
        maxSteps,
        activeStep
      )

      activeQuestion =
        examQuestions.find((item) => item.order === activeStep) || {}
    }

    return (
      <>
        <div className="courseware-details">
          <h2 className="courseware-title">{`${data.name}`}</h2>
          {data.description ? (
            <p className="courseware-description">{data.description}</p>
          ) : (
            ""
          )}
        </div>
        <div
          className={`exam-wrapper ${
            isEmpty(data?.exam_submission) || data?.exam_submission?.submitted
              ? "landing"
              : ""
          } ${showResults ? "-results" : ""}`}
        >
          {showResults ? (
            <>
              <div className="result-header">
                <div>
                  <h3 className="exam-message">
                    You have already submitted the survey form
                  </h3>
                </div>
              </div>
              <p className="exam-subtitle">Question Progress</p>
              <div className="bubble-step" id="questionaires">
                {sortBy(examQuestions, ["order"])?.map((item, i) => (
                  <div
                    key={i}
                    className="step-item"
                    style={
                      item.order === activeStep
                        ? {
                            borderColor: schoolData.primary_color,
                            backgroundColor: "white",
                            color: schoolData.primary_color,
                            height: "32px",
                            width: "32px",
                          }
                        : {}
                    }
                    onClick={() => this.handleSetSelectedPage(item.order - 1)}
                  >
                    {item.order}
                  </div>
                ))}
              </div>
              <div className="bubble-content">
                <p className="question">Question:</p>
                <HTMLContainer>
                  {parse(activeQuestion.text || "")}
                </HTMLContainer>
              </div>
              <div className="exam-answer">
                <span className="answer-label">Your Answer</span>
                <span className="answer">{activeQuestion.answer?.answer}</span>
              </div>
            </>
          ) : (
            <Fragment>
              {isEmpty(data?.exam_submission) ||
              data?.exam_submission.submitted ? (
                <>
                  <h3 className="exam-title">INSTRUCTIONS</h3>
                  <p className="exam-description">{data?.exam?.description}</p>
                  <div className="exam-container">
                    <label className="exam-label">Questions</label>
                    <p className="exam-value">
                      {data?.exam?.total_questions
                        ? data?.exam?.total_questions
                        : "N/A"}
                    </p>
                  </div>
                </>
              ) : (
                <Fragment>
                  <p className="exam-subtitle">Question Progress</p>
                  <div className="bubble-step" id="questionaires">
                    {sortBy(examQuestions, ["order"])?.map((item, i) => (
                      <div
                        key={i}
                        className="step-item"
                        style={
                          item.order === activeStep
                            ? {
                                borderColor: schoolData.primary_color,
                                backgroundColor: "white",
                                color: schoolData.primary_color,
                                height: "32px",
                                width: "32px",
                              }
                            : item.answer?.answer
                            ? {}
                            : {
                                borderColor: "#474b5a",
                                backgroundColor: "white",
                                color: "#474b5a",
                              }
                        }
                        onClick={() => this.handleSelectPage(data.id, i)}
                      >
                        {item.order}
                      </div>
                    ))}
                  </div>
                  <div className="bubble-content">
                    <HTMLContainer>
                      {parse(activeQuestion.text || "")}
                    </HTMLContainer>
                    {this.displayExamType(activeQuestion)}
                  </div>
                  <div className="steps-actions">
                    <div className="steps-action">
                      <Button
                        label="Previous Question"
                        ghost
                        outlined
                        hidden={activeStep <= 1}
                        disabled={activeStep <= 1}
                        onClick={() => this.handlePrevious()}
                      />
                    </div>
                    <div className="steps-action">
                      <Button
                        label={
                          activeStep === data?.exam_submission?.questions.length
                            ? "Submit Survey"
                            : "Next Question"
                        }
                        onClick={() => this.handleNext()}
                      />
                    </div>
                  </div>
                </Fragment>
              )}
            </Fragment>
          )}
        </div>

        {isEmpty(data?.exam_submission) || data?.exam_submission?.submitted ? (
          <div className="steps-actions">
            <div className="steps-action">
              {(data?.exam_submission?.submitted &&
                data?.exam_submission?.passed) ||
              data?.exam?.max_attempts === data?.exam_submission?.attempt ? (
                <>
                  {data?.next && (
                    <Button
                      label="Next Courseware"
                      onClick={() => this.handleViewNextCourseWare()}
                    />
                  )}
                </>
              ) : (
                <Button
                  label="Start Survey"
                  onClick={() => this.handleStartSurvey(data.exam?.id)}
                />
              )}
            </div>
            {data?.exam_submission?.submitted ? (
              <div className="courseware-action">
                <Button
                  label={showResults ? "Hide Answers" : "View Answers"}
                  ghost
                  onClick={() => this.handleViewResults()}
                />
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  courses: state.coursesReducer,
  user: state.userReducer,
  school: state.schoolReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { saveProgress, completeCourseware, startExam, submitAnswer },
    dispatch
  )

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(Survey)
